exports.loadContext = function(callback) {
  var context = require.context('./pages', true);
  if (module.hot) {
    module.hot.accept(context.id, function() {
      context = require.context('./pages', true);
      callback(require.context('./pages', true));
    });
  }
  callback(context);
};



/** WEBPACK FOOTER **
 ** ../app.js
 **/